'use client'

import { CONSENT_CHANGE_EVENT } from '@/lib/analytics-consent'

interface Props {
  className?: string
}

export function CookiePreferencesButton({ className }: Props) {
  function handleClick(): void {
    window.dispatchEvent(new Event(CONSENT_CHANGE_EVENT))
  }

  return (
    <button type="button" onClick={handleClick} className={className}>
      Cookie preferences
    </button>
  )
}
